module.exports = __webpack_public_path__ + "static/media/illustration.bd525f36.svg";